import * as React from 'react';
import { Component } from '../../helpers/Utils';
import { validateControl } from '../../../core/validation/validate';
import { Tooltip } from 'primereact/tooltip';

interface Props {
  dispatcher: any;
  Component: any;
  schema: any;
  disabled: boolean;
  api: any;
  value: any;
  onChange: any;
  setRef: any;
  opts: any;
  rows?: any;
  defaultValue?: any;
  ref: any;
}

interface State {
  value: any;
  error: any;
}

/**
 * Класс который позволяет в Grid использовать обычные компоненты
 */
class GridComponentAdapter extends Component<Props, State> {
  state = {
    value: null,
    error: null,
  };

  componentDidMount() {
    const { value } = this.props;
    if (value) {
      this.setState({ value });
    }
  }

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>,
    prevContext: any,
  ) {
    //Когда меняется state меняем ref родительского компонента, и вызываем функцию onChange которая меняет state одителя исходя из ref
    if (prevState.value !== this.state.value) {
      if (Array.isArray(this.props.value)) {
        this.props.setRef(this.state.value ? this.state.value : []);
        this.props.onChange(this.state.value ? this.state.value : []);
      } else {
        this.props.setRef(this.state.value);
        this.props.onChange(this.state.value);
      }
    }
  }

  //Делаем стандартную валидацию для поля
  validationField(value) {
    const { schema } = this.props;

    const result = validateControl(
      { ...schema, id: schema.field },
      [
        {
          controlid: schema.field,
          value,
        },
      ],
      undefined,
      true,
      undefined,
    );

    // @ts-ignore
    this.setState({ error: result.next()?.value?.error ?? null });
  }

  render() {
    //Тут управляем только состоянием компонента, все остальное излишне
    const {
      dispatcher,
      Component,
      disabled,
      schema,
      opts,
      api,
      defaultValue,
      ref,
    } = this.props;
    const { error, value } = this.state;

    const gridAdapterDispatcher = {
      onBlur: (controlId, value, isError, error) => {
        //Если Blur перехватывает валидацию, не будем мешать
        if (error) {
          this.setState({ value, error });
        } else {
          this.setState({ value });
          this.validationField(value);
        }
      },
      onAddValueRefresh: (id, value, error) => {
        if (error) {
          this.setState({ value, error });
        } else {
          this.setState({ value });
          this.validationField(value);
        }
      },
      onVisit: () => {},
      setError: () => {},
    };

    //TODO Доработать dispatcher пусть он отдает все свои методы,
    // но мы перехватим все те что ниже
    // (чтоб не дублировать методы с получением значений и прочие,
    // которые не влияют на state компонента который тут подключаем)
    return (
      <>
        {schema.extra?.tooltip && (
          // @ts-ignore
          // TODO: !!!
          <Tooltip
            className="controls-tooltip modal-tooltip"
            target={`.${schema.field}`}
            at={`.${schema.field}`}
            autoHide={false}
            appendTo={ref?.current}
          >
            <span>{schema.extra.tooltip}</span>
          </Tooltip>
        )}
        <div className="grid-adapter" key={schema.field}>
          <Component
            schema={{
              ...schema,
              disabled,
              value,
            }}
            dispatcher={{
              ...dispatcher,
              ...gridAdapterDispatcher,
            }}
            error={error}
            visited={true}
            opts={opts}
            api={api}
            defaultValue={defaultValue}
          />
        </div>
      </>
    );
  }
}

export default GridComponentAdapter;
